import {
  AgnesSelect,
  AgnesSelectContent,
  AgnesSelectItem,
  AgnesSelectTrigger,
  AgnesSelectValue,
} from '@agnes/ui';

const SELECT_TRIGGER =
  '[&>[data-slot=select-value]]:min-w-0 [&>[data-slot=select-value]]:flex-1 [&>[data-slot=select-value]]:truncate [&>[data-slot=select-value]]:text-left';

/** Select compacto de filtro inline; sem opções mostra `emptyText` no lugar da lista. */
export function SelectInline({
  placeholder,
  value,
  onValueChange,
  options,
  emptyText,
  width = 'w-56',
  dataQa,
}: {
  placeholder: string;
  value: string;
  onValueChange: (v: string) => void;
  options: { value: string; label: string }[];
  emptyText?: string;
  width?: string;
  dataQa: string;
}) {
  return (
    <AgnesSelect value={value} onValueChange={onValueChange}>
      <AgnesSelectTrigger className={`${width} ${SELECT_TRIGGER}`} dataQa={dataQa}>
        <AgnesSelectValue
          placeholder={options.length === 0 ? (emptyText ?? placeholder) : placeholder}
        />
      </AgnesSelectTrigger>
      <AgnesSelectContent dataQa={`${dataQa}-lista`}>
        {options.length === 0 ? (
          <AgnesSelectItem value="__empty__" disabled dataQa={`${dataQa}-empty`}>
            {emptyText ?? 'Nenhuma opção disponível'}
          </AgnesSelectItem>
        ) : (
          options.map((o) => (
            <AgnesSelectItem key={o.value} value={o.value} dataQa={dataQa}>
              {o.label}
            </AgnesSelectItem>
          ))
        )}
      </AgnesSelectContent>
    </AgnesSelect>
  );
}
